import { JSXElementConstructor } from "react";
import { TbBrandMercedes, TbBrandToyota, TbBrandVolkswagen } from "react-icons/tb";

import { softColors } from "./colors";

export type VehicleBrandItem = {
    component: () => JSXElementConstructor<{}>;
    hover: string;
    bg: string;
    text: string;
    values: string[];
};

export type VehicleBrandList = VehicleBrandItem[];

function OpelIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            id="Ebene_1"
            x="0px"
            y="0px"
            viewBox="-194 -4.039 1000 800.078"
            className=" !w-4 !h-4 translate-x-1"
        >
            <path d="M305.806,739.641C117.94,739.641-37.836,583.864-37.836,396c0-9.724,0.39-19.447,1.362-28.977l287.437,17.892  l-124.271,85.959c-1.75,1.166-2.723,3.111-2.723,5.251c0,3.501,2.917,6.418,6.418,6.418h507.585  C599.076,629.372,463.721,739.641,305.806,739.641L305.806,739.641z M305.806,52.359c187.863,0,343.642,155.775,343.642,343.641  c0,9.725-0.391,19.253-1.168,28.783l-287.244-18.281l124.661-85.376c1.751-1.167,2.723-3.111,2.723-5.25  c0-3.501-2.917-6.418-6.417-6.418H-26.361C12.729,162.627,147.89,52.359,305.806,52.359L305.806,52.359z M798.61,434.313  l-93.933-6.029c0.777-10.696,1.361-21.588,1.361-32.477C705.845,175.074,526.731-4.039,305.806-4.039  c-191.17,0-351.031,134.189-390.51,313.302h-73.901c-4.863,0-9.141,2.334-11.863,5.834l-21.976,30.338  c-0.973,1.361-1.556,2.918-1.556,4.669c0,4.083,3.306,7.583,7.585,7.583l93.543,5.834c-0.778,10.696-1.362,21.587-1.362,32.478  c0,220.926,179.113,400.039,400.04,400.039c191.171,0,351.03-134.188,390.509-313.303h74.292c4.86,0,9.139-2.333,11.861-5.834  l21.977-30.338c0.972-1.361,1.556-2.918,1.556-4.668C806,437.813,802.695,434.313,798.61,434.313L798.61,434.313z" />
        </svg>
    );
}
export const vehicleBrands: VehicleBrandList = [
    {
        component: () => TbBrandToyota,
        ...softColors.green,
        values: ["TOYOTA"],
    },
    {
        component: () => TbBrandToyota,
        ...softColors.green,

        values: ["TOYOTA"],
    },
    {
        component: () => TbBrandVolkswagen,
        ...softColors.purple,

        values: ["Volkswagen", "VOLKSWAGEN"],
    },
    {
        component: () => TbBrandMercedes,
        ...softColors.blueGrey,
        values: ["Mercedes-Benz", "MERCEDES", "MERCEDES-BENZ"],
    },
    {
        component: () => OpelIcon,
        ...softColors.blueGrey,
        values: ["OPEL"],
    },
];
